import React from 'react'

import { Heading } from '../Heading'
import type { SubsectionProps } from './types'
import * as S from './styled'

export const Subsection = ({
  title,
  id,
  borderless = false,
  noMargin = false,
  rightContent,
  children,
}: SubsectionProps) => (
  <S.Container id={id}>
    {title && (
      <S.Title $borderless={borderless} $noMargin={noMargin}>
        <S.HeadingContainer>
          <S.Heading>
            <Heading type="h4" weight="semibold">
              {title}
            </Heading>
          </S.Heading>
          {rightContent && <S.RightContent>{rightContent}</S.RightContent>}
        </S.HeadingContainer>
      </S.Title>
    )}
    {children}
  </S.Container>
)
